import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { styled } from '@mui/system';
import { Grid } from "@mui/material";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

const theme = createTheme({
  palette: {
    primary: {
      main: '#e37b26',
    },

  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#ff9c4a',
          '&:hover': {
            backgroundColor: '#c49b7d', // Optional: specify a hover color
          },
        },
      },
    },
  },
});

export const ButtonTextGrid = styled(Grid)(() => ({
  color:'white',fontWeight:'bold' ,display:'flex'
}));

root.render(
    <React.StrictMode>
          <ThemeProvider theme={theme}>
        <Provider store={store}>
            <BrowserRouter>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <App />
                </LocalizationProvider>
            </BrowserRouter>
        </Provider>
        </ThemeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
